module.exports = "Upload your photo to the image editor"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-how-to-step-one.md
// module id = 1165
// module chunks = 0